import { FC } from 'react';

import { TertiaryButton } from '../button2';

import { CallToActionButtonWrapper, Header, HeaderContainer } from './section-header.styled';
import { ISectionHeaderProps } from './types';

/**
 * section header component for home page sections
 */
const SectionHeader: FC<ISectionHeaderProps> = ({
  callToActionAs,
  callToActionLink,
  callToActionText,
  headerText,
  id: headerId,
  variant,
  className,
}) => {
  if (variant === 'header-only') {
    return (
      <HeaderContainer variant={variant} className={className}>
        <Header variant={variant} id={headerId}>
          {headerText}
        </Header>
      </HeaderContainer>
    );
  }

  return (
    <HeaderContainer variant={variant} className={className}>
      <Header variant={variant} id={headerId}>
        {headerText}
      </Header>
      <CallToActionButtonWrapper>
        {callToActionAs && (
          <TertiaryButton as={callToActionAs} to={callToActionLink} size="small" showNavigationIcon>
            {callToActionText}
          </TertiaryButton>
        )}
      </CallToActionButtonWrapper>
    </HeaderContainer>
  );
};

export default SectionHeader;
